const ALLOWED_METADATA_TREE_OPERATIONS = {
  ADD_ROOT: 'ADD_ROOT',
  ADD_CHILD: 'ADD_CHILD',
  DELETE: 'DELETE',
  RENAME: 'RENAME',
  SET_IS_CURATION_ENABLED: 'SET_IS_CURATION_ENABLED',
  MOVE: 'MOVE',
  MOVE_TO: 'MOVE_TO',
  REPLACE: 'REPLACE',
  REVERT_REPLACE: 'REVERT_REPLACE',
  SKIP_SET_IS_CURATION_ENABLED: 'SKIP_SET_IS_CURATION_ENABLED',
}

export default ALLOWED_METADATA_TREE_OPERATIONS
